// tracking/data-form
import {
  postData,
  postFormData,
  createFormData,
  postRequest,
} from 'src/services/RestApi';

function requestParams(values) {
  const params = {
    myId: values.myId,
    studentId: values.studentId,
    trackingId: values.trackingField
  };
  if(values.statusField) params.statusId = values.statusField;
  if(values.remindField) params.remindAt = values.remindField;
  if(values.note) params.note = values.note;
  if(values.updatedField) params.updatedAt = values.updatedField;
  return params;
}

export const apiCreateST = async (values) => {
  const queryParam = {
    studentId: values.studentId,
    trackingId: values.trackingField,
    statusId: values.statusField,
    // remindAt: values.remindField,
    // note: values.note,
  };
  if(values.remindField) queryParam.remindAt = values.remindField;
  if(values.note) queryParam.note = values.note;
  if(values.updatedField) queryParam.updatedAt = values.updatedField;
  // if(values.myRepeated) queryParam.repeated = values.myRepeated;

  // console.log('Params: ', queryParam);
  return await postRequest(
    'api/tracking/student/create', {}, queryParam
  );
};

export const apiUpdateST= async (values) => {
  // const queryParam = {
  //   myId: values.myId,
  //   studentId: values.studentId,
  //   trackingId: values.trackingField,
  //   statusId: values.statusField,
  //   remindAt: values.remindField,
  // };
  const queryParam = requestParams(values);
  // console.log('Params: ', queryParam);
  return await postData(
    'api/tracking/student/update', queryParam
  );
};

export const apiDeleteST = async (values) => {
  // const queryData = requestParams(values);
  const queryParam = requestParams(values);
  // console.log('Params: ', queryParam);
  return await postRequest(
    'api/tracking/student/delete', {}, queryParam
  );
};

